<template>
  <div>
    <div v-show="this.error_message !== ''" style="color: red; font-size: 20px; font-weight: 600; text-align: center;">error_meesage: {{ error_message }}</div>
    <input type="file" ref="fileInput">
    <div ref="progressDiv"></div>
    <button @click="handleUpload">传给后端</button>
    <el-input
      style="margin:3px;"
      placeholder="请输入课程路径名称"
      v-model="urlName"
      clearable>
    </el-input>
    <el-input
      style="margin:3px;"
      placeholder="请输入标题"
      v-model="title"
      clearable>
    </el-input>
    <span>视频编号：  </span><el-input-number style="margin:3px;" v-model="number" :min="1" :max="100" label="描述文字"></el-input-number>
    <el-button type="text" style="margin-left: 260px;" @click="CreateVideo">添加课程视频</el-button>

    <hr>
    <div class="row text-center" v-for="l in list" :key="l.id">
      <!-- <div class="col-1">catalogId = {{ l.catalogId }}</div> -->
      <div class="col-6">url = {{ l.url }}</div>
      <div class="col-2">title =  {{ l.title }}</div>
      <div class="col-2">number = {{ l.number }}</div>
      <div class="col-2">
        <el-popover
            placement="bottom"
            title="修改课程视频"
            width="700"
            trigger="click"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
            >
            <el-input
                type="text"
                placeholder="请输入标题"
                v-model="title"
                maxlength="100"
                show-word-limit
                >
            </el-input>
            <el-input
                type="text"
                placeholder="请输入课程路径名字"
                v-model="urlName"
                maxlength="100"
                show-word-limit
                >
            </el-input>
            <span>视频编号id:</span>
            <el-input-number 
                placeholder="请输入编号"
                style="margin-top: 10px; margin-left: 10px;" 
                v-model="number" 
                :min="1" 
                :max="100" 
                label="123"
                >
            </el-input-number>
            <div>
                <el-button type="text" style="margin-left: 290px;" @click="UpdateVideo(l.id)">上传到后端</el-button>
            </div>
            <el-button slot="reference" type="text" style="margin-left: 10PX;" @click="openUpdate(l)">修改视频</el-button>
        </el-popover>

        <el-button style="margin-left: 4px;" type="text" @click="DeleteVideo(l.id)">删除视频</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { uploadFile } from './vid-upload'
  import Url from '@/constant/Url'

  export default {
    name:'CourseVideoTemplate',
    props:["cId"],
    data() {
      return {
        url:'',
        title:'',
        number:'',
        urlName:'',
        error_message:'',

        list:[],
      }
    },
    mounted() {
      this.ReadVideo()
    },
    methods: {
      openUpdate(item) {
        this.title = item.title
        this.number = item.number
        this.urlName = ""
      },
      UpdateVideo(id) { // 修改视频
        const vue = this
        const store = this.$store

        $.ajax({
          url: Url.uCourseVideoUrl,
          type:'post',
          headers: {
            Authorization: "Bearer " + store.state.me.token,
          },
          data: {
            id: id,
            catalogId: vue.cId,
            url: vue.urlName,
            title: vue.title,
            number: vue.number,
          },
          success(resp) {
            if (resp.error_message === "success") {
              vue.error_message = "success"
              vue.ReadVideo()
            } else {
              vue.error_message = resp.error_message
            }
          },
          error(resp) {
            console.log("修改课程视频彻底失败了, resp == >", resp)
          }
        })
      },
      DeleteVideo(id) { // 删除视频
        const vue = this
        const store = this.$store

        $.ajax({
          url: Url.dCourseVideoUrl,
          type:'post',
          headers: {
            Authorization: "Bearer " + store.state.me.token,
          },
          data: {
            id: id,
          },
          success(resp) {
            if (resp.error_message === "success") {
              vue.error_message = "删除视频成功了"
              vue.ReadVideo()
            } else {
              vue.error_message = resp.error_message
            }
          },
          error(resp) {
            console.log("创建课程视频彻底失败了, resp == >", resp)
          }
        })
      },
      CreateVideo() { // 创建课程页面
        // console.log("url == >", Url.cCourseVideoUrl)
        const vue = this
        const store = this.$store

        $.ajax({
          url: Url.cCourseVideoUrl,
          type:'post',
          headers: {
            Authorization: "Bearer " + store.state.me.token,
          },
          data: {
            catalogId: vue.cId,
            url: "https://app6132.acapp.acwing.com.cn/media/" + vue.urlName + "/stream.mpd",
            title: vue.title,
            number: vue.number,
          },
          success(resp) {
            if (resp.error_message === "success") {
              vue.error_message = "success"
              vue.ReadVideo()
            } else {
              vue.error_message = resp.error_message
            }
          },
          error(resp) {
            console.log("创建课程视频彻底失败了, resp == >", resp)
          }
        })
      },
      ReadVideo() { // 获取课程视频
        const vue = this
        const store = this.$store

        $.ajax({
          url: Url.rCourseVideoUrl,
          type:'post',
          headers: {
            Authorization: "Bearer " + store.state.me.token,
          },
          data: {
            catalogId: vue.cId, // 目录id
          },
          success(resp) {
            if (resp.error_message === "success") {
              vue.error_message = "课程获取成功"
              vue.list = JSON.parse(resp.list)
              console.log("list == > ", vue.list)
            } else {
              vue.error_message = resp.error_message
            }
          },
          error(resp) {
            console.log("获取课程视频彻底失败了, resp == >", resp)
          }
        })
      },
      handleUpload() {
        const fileInput = this.$refs.fileInput;
        console.log("fileInput", fileInput.files[0])
        const progressDiv = this.$refs.progressDiv;
        let classname = this.urlName;
        if (classname === undefined || classname === "") {
          this.error_message = "请先保证urlName不为空"
          return
        }
        this.error_message = "上传视频成功了"
        const file = fileInput.files[0];
        uploadFile(file, progressDiv, classname);
      },
    },
  };
</script>

<style scoped>

</style>
